var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 1.5,
    fill: "#F3F6F9",
    stroke: "#E1EAF3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10842_1911",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10842_1911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.98557 16.375C8.47794 16.375 7.14913 15.9149 5.99913 14.9946C4.84913 14.0745 4.11207 12.8971 3.78794 11.4625C3.74757 11.3135 3.77188 11.1765 3.86088 11.0515C3.94976 10.9265 4.07569 10.8539 4.23869 10.8336C4.39207 10.8135 4.52957 10.8438 4.65119 10.9246C4.77282 11.0053 4.85769 11.1241 4.90582 11.2808C5.19132 12.4394 5.80644 13.3906 6.75119 14.1344C7.69594 14.8781 8.77407 15.25 9.98557 15.25C11.4481 15.25 12.6887 14.7406 13.7074 13.7219C14.7262 12.7031 15.2356 11.4625 15.2356 10C15.2356 8.5375 14.7262 7.29688 13.7074 6.27813C12.6887 5.25938 11.4481 4.75 9.98557 4.75C9.16632 4.75 8.39857 4.932 7.68232 5.296C6.96594 5.65987 6.34907 6.16056 5.83169 6.79806H7.23082C7.39019 6.79806 7.52376 6.852 7.63151 6.95987C7.73938 7.06775 7.79332 7.20138 7.79332 7.36075C7.79332 7.52025 7.73938 7.65381 7.63151 7.76144C7.52376 7.86919 7.39019 7.92306 7.23082 7.92306H4.66357C4.47144 7.92306 4.31044 7.85806 4.18057 7.72806C4.05057 7.59819 3.98557 7.43719 3.98557 7.24506V4.67781C3.98557 4.51844 4.03951 4.38488 4.14738 4.27713C4.25526 4.16925 4.38894 4.11531 4.54844 4.11531C4.70782 4.11531 4.84138 4.16925 4.94913 4.27713C5.05676 4.38488 5.11057 4.51844 5.11057 4.67781V5.89225C5.71919 5.174 6.44807 4.61656 7.29719 4.21994C8.14619 3.82331 9.04232 3.625 9.98557 3.625C10.8706 3.625 11.6995 3.79231 12.4724 4.12694C13.2453 4.46156 13.9192 4.91637 14.4942 5.49137C15.0692 6.06637 15.524 6.74025 15.8586 7.513C16.1933 8.28587 16.3606 9.11475 16.3606 9.99963C16.3606 10.8845 16.1933 11.7134 15.8586 12.4864C15.524 13.2596 15.0692 13.9336 14.4942 14.5086C13.9192 15.0836 13.2453 15.5384 12.4724 15.8731C11.6995 16.2077 10.8706 16.375 9.98557 16.375ZM10.5696 9.77219L12.6321 11.8347C12.736 11.9384 12.7891 12.0689 12.7915 12.2262C12.794 12.3834 12.7409 12.5164 12.6321 12.625C12.5235 12.7336 12.3918 12.7879 12.2371 12.7879C12.0822 12.7879 11.9504 12.7336 11.8418 12.625L9.64807 10.4312C9.57794 10.361 9.52651 10.2845 9.49376 10.2017C9.46113 10.119 9.44482 10.0335 9.44482 9.94525V6.8125C9.44482 6.65313 9.49869 6.5195 9.60644 6.41162C9.71432 6.30387 9.84801 6.25 10.0075 6.25C10.1669 6.25 10.3004 6.30387 10.4082 6.41162C10.5158 6.5195 10.5696 6.65313 10.5696 6.8125V9.77219Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.2bc96827694a2c710721f889b7193409.svg";
export { ForwardRef as ReactComponent };